<mat-card>
	<mat-card-header>
		<mat-card-title>
			{{title}}
			<mat-icon *ngIf="isLoading">
				<mat-spinner diameter="20"> </mat-spinner>
			</mat-icon>
			<button class="close-button" mat-mini-fab (click)="closeDialog(false)">
				<mat-icon>close</mat-icon>
			</button>
		</mat-card-title>
	</mat-card-header>

	<mat-card-content>
		<hr />

		<div class="text-center" *ngIf="students.length <= 1">
			<h2
				*ngIf="!schoolEnrollments || (schoolEnrollments && schoolEnrollments.length === 0) && !serviceDelivery && !cosMode">
				Child
				must have a valid
				enrollment for the school year selected.</h2>
			<h2
				*ngIf="!chosenSchoolEnrollment && schoolEnrollments && schoolEnrollments.length > 0 && !serviceDelivery && !cosMode">
				Please
				select a school
				enrollment.</h2>
			<h2 *ngIf="serviceDelivery && !chosenSchoolEnrollment && !cosMode">---</h2>
			<h2 *ngIf="!!chosenSchoolEnrollment && !cosMode">Grade: {{chosenSchoolEnrollment.Grade}} - Type:
				{{chosenSchoolEnrollment.EnrollmentType}}</h2>


			<h2 *ngIf="cosMode">Use Only For COS</h2>
		</div>

		<hr *ngIf="students.length <= 1" />

		<mat-accordion *ngIf="students.length > 1" class="margin-top-md">
			<mat-expansion-panel>
				<mat-expansion-panel-header>
					<mat-panel-title> {{studentLength}} Child(ren) selected &nbsp; <mat-icon *ngIf="isLoadingGroup">
							<mat-spinner diameter="20"> </mat-spinner>
						</mat-icon>
					</mat-panel-title>
					<mat-panel-description *ngIf="selectedChildrenFilter">
						Filter:
						{{selectedChildrenTableDataSource?.filteredData?.length === uniqueStudents.length ?
						uniqueStudents.length :
						(selectedChildrenTableDataSource?.filteredData?.length + '/' + uniqueStudents.length)}}
						Child(ren)
					</mat-panel-description>
				</mat-expansion-panel-header>


				<div class="row">
					<mat-form-field class="col-lg-12">
						<mat-label>
							Filter
						</mat-label>
						<input matInput id="filter" name="filter" type="string" [(ngModel)]="selectedChildrenFilter"
							(ngModelChangeDebounced)="setSelectedChildrenFilter();" />
					</mat-form-field>
				</div>

				<div class="table-responsive">
					<mat-table [dataSource]="selectedChildrenTableDataSource" class="mat-elevation-z1" matSort>

						<ng-container matColumnDef="EDIT">
							<mat-header-cell *matHeaderCellDef>
								<button mat-icon-button color="primary" (click)="toggleAllStudents()"
									*ngIf="!hasAtLeastOneStudent()">
									<mat-icon>check_box_outline_blank</mat-icon>
								</button>
								<button mat-icon-button color="primary" (click)="toggleAllStudents()"
									*ngIf="hasAtLeastOneStudent() && hasDifferentCounts()">
									<mat-icon>indeterminate_check_box</mat-icon>
								</button>
								<button mat-icon-button color="primary" (click)="toggleAllStudents()"
									*ngIf="hasAtLeastOneStudent() && !hasDifferentCounts()">
									<mat-icon>check_box</mat-icon>
								</button>
							</mat-header-cell>
							<mat-cell *matCellDef="let element">
								<button mat-icon-button color="primary" (click)="toggleStudent(element)"
									[hidden]="element.ENABLED"
									[ngClass]="{'disabled cursor-default': element.GRADUATED}">
									<mat-icon>check_box_outline_blank</mat-icon>
								</button>
								<button mat-icon-button color="primary" (click)="toggleStudent(element)"
									[hidden]="!element.ENABLED"
									[ngClass]="{'disabled cursor-default': element.GRADUATED}">
									<mat-icon>check_box</mat-icon>
								</button>
							</mat-cell>
						</ng-container>

						<ng-container matColumnDef="MSD_NUMBER">
							<mat-header-cell *matHeaderCellDef mat-sort-header> MSD Number </mat-header-cell>
							<mat-cell *matCellDef="let element">
								{{element.MSD_NUMBER}}
							</mat-cell>
						</ng-container>

						<ng-container matColumnDef="PERSON.LAST_NAME">
							<mat-header-cell *matHeaderCellDef mat-sort-header> Name </mat-header-cell>
							<mat-cell *matCellDef="let element"> {{element.PERSON.LAST_NAME |
								titlecase}}{{(element.SECOND_LAST_NAME
								? ' ' + element.SECOND_LAST_NAME + ',': ',') | titlecase}} {{element.PERSON.FIRST_NAME |
								titlecase}}
								{{element.PERSON.MIDDLE_INITIAL | titlecase}}</mat-cell>
						</ng-container>

						<ng-container matColumnDef="SCHOOL_ENROLLMENT_DETAILS[0].GRADE">
							<mat-header-cell *matHeaderCellDef mat-sort-header> Grade </mat-header-cell>
							<mat-cell *matCellDef="let element" class="row">
								<div *ngFor="let sed of element.SCHOOL_ENROLLMENT_DETAILS">{{sed.GRADE}}</div>
							</mat-cell>
						</ng-container>

						<ng-container matColumnDef="SCHOOL_ENROLLMENT_DETAILS[0].ENROLLMENT_TYPE">
							<mat-header-cell *matHeaderCellDef mat-sort-header> Enroll Type </mat-header-cell>
							<mat-cell *matCellDef="let element" class="row">
								<div *ngFor="let sed of element.SCHOOL_ENROLLMENT_DETAILS">{{sed.ENROLLMENT_TYPE}}</div>
							</mat-cell>
						</ng-container>

						<ng-container matColumnDef="SCHOOL_ENROLLMENT_DETAILS[0].ENROLLMENT_DATE">
							<mat-header-cell *matHeaderCellDef mat-sort-header> Enroll Date </mat-header-cell>
							<mat-cell *matCellDef="let element" class="row">
								<div *ngFor="let sed of element.SCHOOL_ENROLLMENT_DETAILS">{{sed.ENROLLMENT_DATE |
									simpleDate}}</div>
							</mat-cell>
						</ng-container>

						<ng-container matColumnDef="SCHOOL_ENROLLMENT_DETAILS[0].WITHDRAWAL_DATE">
							<mat-header-cell *matHeaderCellDef mat-sort-header> Withdrawal Date </mat-header-cell>
							<mat-cell *matCellDef="let element" class="row">
								<div *ngFor="let sed of element.SCHOOL_ENROLLMENT_DETAILS">{{sed.WITHDRAWAL_DATE |
									simpleDate}}</div>
							</mat-cell>
						</ng-container>

						<ng-container
							matColumnDef="SCHOOL_ENROLLMENT_DETAILS[0].STUDENT_ELIGIBILITIES[0].ELIGIBILITY_END_DATE">
							<mat-header-cell *matHeaderCellDef mat-sort-header> EoE </mat-header-cell>
							<mat-cell *matCellDef="let element" class="row">
								<div *ngFor="let sed of element.SCHOOL_ENROLLMENT_DETAILS">
									{{sed.STUDENT_ELIGIBILITIES[0].ELIGIBILITY_END_DATE | simpleDate}}</div>
							</mat-cell>
						</ng-container>

						<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
						<mat-row *matRowDef="let row; columns: displayedColumns;"
							[ngClass]="{'terminatedRow': row.STUDENT_TERMINATION_STATUSES?.length > 0 && row.STUDENT_TERMINATION_STATUSES[0].STUDENT_TERMINATION_STATUS_TYPES_ID !== 1}"
							[matTooltip]="row.STUDENT_TERMINATION_STATUSES && row.STUDENT_TERMINATION_STATUSES[0].STUDENT_TERMINATION_STATUS_TYPES.TYPE"
							[matTooltipPosition]="'above'"
							[matTooltipDisabled]="row.STUDENT_TERMINATION_STATUSES?.length === 0 || (row.STUDENT_TERMINATION_STATUSES && row.STUDENT_TERMINATION_STATUSES[0].STUDENT_TERMINATION_STATUS_TYPES_ID === 1)"
							[matTooltipClass]="'terminatedTooltip'"></mat-row>
					</mat-table>
				</div>
				<mat-paginator #paginators
					[pageSizeOptions]="[5, 10, 20, (selectedChildrenTableDataSource ? selectedChildrenTableDataSource.data.length > 100 ? selectedChildrenTableDataSource.data.length : 100 : 100)]"
					showFirstLastButtons aria-label="Select page of periodic elements"
					[hidden]="selectedChildrenTableDataSource?.filteredData?.length === 0">
				</mat-paginator>
			</mat-expansion-panel>
		</mat-accordion>

		<div class="padding-vertical-md" *ngIf="!isLoading">
			<form [formGroup]="form" (ngSubmit)="submit()" #enrollmentForm="ngForm">

				<div class="row">
					<div class="col-lg-4">
						<div class="row">
							<app-school-year class="col-lg-12" [label]="'School Year'" [yearType]="'PerformancePeriod'"
								(performancePeriodEvent)="schoolYearEvent($event)" [currentYearModifier]="0"
								[yearsBack]="1" [yearsForward]="1" [reset]="resetField"
								[selectSchoolYear]="selectSchoolYear"
								[disabled]="!!serviceDelivery || students.length > 1" [required]="true">
							</app-school-year>
						</div>
					</div>


					<div class="col-lg-8">
						<div class="row" *ngIf="!serviceDelivery && !cosMode && students.length <= 1">
							<mat-form-field class="col-lg-12">
								<mat-label>
									School Enrollment
								</mat-label>
								<mat-select formControlName="schoolEnrollment"
									(selectionChange)="schoolEnrollmentChange($event)">
									<mat-option *ngFor="let schoolEnrollment of schoolEnrollments"
										[value]="schoolEnrollment">
										{{'[Region ' + schoolEnrollment.REGION.CODE + '] - '
										+ schoolEnrollment.SchoolYear + ': '
										+ schoolEnrollment.SCHOOL.ORGANIZATION.NAME
										+ ' (' + schoolEnrollment.Grade + '/' + schoolEnrollment.EnrollmentType + ')'
										+ ' [' + '' + (schoolEnrollment.EnrollmentDate ?
										simpleDate(schoolEnrollment.EnrollmentDate) : 'No Enrollment Date') +
										(schoolEnrollment.WithdrawalDate ? ' - ' +
										simpleDate(schoolEnrollment.WithdrawalDate) : ' - No Withdrawal Date') + '' +
										']'}}
									</mat-option>
								</mat-select>
							</mat-form-field>
						</div>
						<div class="row">
							<div class="col-lg-6">
								<div class="row">
									<region-dropdown-two-way *ngIf="!isLoading && mode !== 'view'" class="col-lg-12"
										[isMultiple]="false" [(selectedRegions)]="chosenRegions"
										[(selectedRegion)]="chosenRegion" [reset]="resetField" [required]="true"
										[disabled]="true" [selectUserRegion]="!serviceDelivery">
									</region-dropdown-two-way>

									<mat-form-field appearance="fill" class="col-lg-12"
										*ngIf="!isLoading && mode === 'view'">
										<mat-label>
											Region
										</mat-label>
										<input matInput placeholder="Region" [(ngModel)]="serviceDelivery.REGION.NAME"
											[ngModelOptions]="{standalone: true}" disabled />
									</mat-form-field>
								</div>
							</div>
							<div class="col-lg-6">
								<div class="row">

									<county-dropdown-two-way *ngIf="!isLoading && mode !== 'view' && cosMode"
										class="col-lg-12" [isMultiple]="false" [(selectedCounties)]="chosenCounties"
										[(selectedCounty)]="chosenCounty" [reset]="resetField" [isMultiple]="false"
										[required]="true" [regions]="chosenRegions"
										(selectedCountiesChange)="countiesEventEmitter($event)">
									</county-dropdown-two-way>

									<mat-form-field appearance="fill" class="col-lg-12"
										*ngIf="mode === 'view' || !cosMode">
										<mat-label>
											County
										</mat-label>
										<input matInput placeholder="County" [(ngModel)]="chosenCountyName"
											[ngModelOptions]="{standalone: true}" disabled />
									</mat-form-field>
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col-lg-6">
								<div class="row">

									<district-dropdown-two-way *ngIf="!isLoading && mode !== 'view' && cosMode"
										class="col-lg-12" [isMultiple]="false"
										[(selectedSchoolDistricts)]="chosenSchoolDistricts"
										[(selectedSchoolDistrict)]="chosenSchoolDistrict" [reset]="resetField"
										[required]="true" [isMultiple]="false" [regions]="chosenRegions"
										[counties]="chosenCounties"
										(selectedSchoolDistrictsChange)="districtsEventEmitter($event)">
									</district-dropdown-two-way>

									<mat-form-field appearance="fill" class="col-lg-12"
										*ngIf="mode === 'view' || !cosMode">
										<mat-label>
											School District
										</mat-label>
										<input matInput placeholder="School District"
											[(ngModel)]="chosenSchoolDistrictName" [ngModelOptions]="{standalone: true}"
											disabled />
									</mat-form-field>
								</div>
							</div>
							<div class="col-lg-6">
								<div class="row">

									<school-dropdown-two-way *ngIf="!isLoading && mode !== 'view' && cosMode"
										class="col-lg-12" [isMultiple]="false" [(selectedSchool)]="chosenSchool"
										[reset]="resetField" [required]="true" [regions]="chosenRegions"
										[counties]="chosenCounties" [schoolDistricts]="chosenSchoolDistricts"
										(selectedSchoolsChange)="schoolsEventEmitter($event)">
									</school-dropdown-two-way>

									<mat-form-field appearance="fill" class="col-lg-12"
										*ngIf="mode === 'view' || !cosMode">
										<mat-label>
											School
										</mat-label>
										<input matInput placeholder="School" [(ngModel)]="chosenSchoolName"
											[ngModelOptions]="{standalone: true}" disabled />
									</mat-form-field>
								</div>
							</div>
						</div>
						<div class="row" [hidden]="!cosMode">
							<div class="col-lg-6">
								<grade-dropdown class="col-lg-12" [(chosenGrades)]="chosenGrades" [required]="true"
									(gradeEvent)="gradeEventEmitter($event)" [isMultiple]="false" [reset]="resetField"
									[disabled]="mode === 'view'">
								</grade-dropdown>
							</div>
							<div class="col-lg-6">
							</div>
						</div>
					</div>

				</div>

				<hr />

				<div class="row">
					<div class="col-lg-4">
						<div class="row">
							<mat-form-field class="col-lg-12">
								<mat-label>
									Service Period
								</mat-label>
								<mat-select formControlName="enrollmentType"
									(selectionChange)="enrollmentPeriodChange($event)">
									<mat-option *ngFor="let enrollmentPeriod of enrollmentPeriods"
										[value]="enrollmentPeriod.PERIOD" [disabled]="mode === 'view'">
										{{enrollmentPeriod.PERIOD}}
									</mat-option>
								</mat-select>
							</mat-form-field>
						</div>
					</div>
					<div class="col-lg-8">
						<div class="row">
							<service-dropdown (serviceEvent)="serviceEventEmitter($event)"
								[isMultiple]="!serviceDelivery" [region]="chosenRegion"
								[enrollmentPeriods]="chosenEnrollmentPeriods" [activeOnly]="mode !== 'view'"
								[selectServices]="selectServices" [reset]="resetField" [required]="true"
								[grades]="[chosenGrade]" [disabled]="mode === 'view'">
							</service-dropdown>
						</div>
						<div class="row" *ngIf="chosenServiceHoursRequired && chosenServiceHoursRequired.length > 0">
							<div *ngIf="mode !== 'view'">Enter service hours below (required)</div>
							<div *ngIf="mode === 'view'">Service Hours</div>
							<hr />
							<div *ngFor="let partyService of chosenServiceHoursRequired">
								<h4>{{partyService.SERVICE_NAME}}</h4>
								<div>
									<ul class="leaders">
										<li>
											<span>- {{partyService.MEASURABLE_PROGRAM_OBJECTIVES?.NAME}}</span>

											<span>
												<mat-form-field appearance="outline">
													<mat-label>
														Service Hours
													</mat-label>
													<mat-select [formControlName]="partyService.ID!.toString()">
														<mat-option
															*ngFor="let serviceHourRange of partyService.MEASURABLE_PROGRAM_OBJECTIVES?.SERVICE_HOUR_RANGES"
															[value]="serviceHourRange">
															{{(serviceHourRange.MIN + (serviceHourRange.MAX ? ' - ' +
															serviceHourRange.MAX : ' +') + ' hour(s)')}}
														</mat-option>
													</mat-select>
												</mat-form-field>
											</span>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="row">
					<div class="col-lg-4">
						<div class="row">
							<mat-form-field class="col-lg-12">
								<mat-label>
									Start Date
								</mat-label>
								<input matInput formControlName="startDate" [matDatepicker]="startDatePicker"
									(click)="startDatePicker.open()" startView="multi-year"
									[min]="startDateOptions.minDate" [max]="startDateOptions.maxDate">
								<mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
								<mat-datepicker #startDatePicker startView="multi-year"
									[startAt]="startDateOptions.startAt"></mat-datepicker>
							</mat-form-field>
						</div>
					</div>
					<div class="col-lg-8">
						<div class="row">
							<div class="col-lg-6">
								<div class="row">
									<mat-form-field class="col-lg-12">
										<mat-label>
											End Date
										</mat-label>
										<input matInput formControlName="endDate" [matDatepicker]="endDatePicker"
											(click)="endDatePicker.open()" startView="multi-year"
											[min]="endDateOptions.minDate" [max]="endDateOptions.maxDate">
										<mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
										<mat-datepicker #endDatePicker startView="multi-year"
											[startAt]="endDatePicker.startAt"></mat-datepicker>
									</mat-form-field>
								</div>
							</div>
							<div class="col-lg-6 inline" *ngIf="cosMode">
								<mat-form-field class="w-100">
									<mat-label>
										COS Type
									</mat-label>
									<mat-select formControlName="cosType" (selectionChange)="cosChange($event)">
										<mat-option *ngFor="let cosReason of cosReasons" [value]="cosReason">
											{{cosReason.REASON}} - {{cosReason.DESCRIPTION}}
										</mat-option>
									</mat-select>
								</mat-form-field>
								<help-text-btn class="align-help-text-btn"
									[helpTextId]="'Child_Services_COSType'"></help-text-btn>
							</div>
						</div>
					</div>
				</div>

				<div class="row"
					*ngIf="selectedSchoolYear && chosenEnrollmentPeriods && chosenEnrollmentPeriods.length > 0 && chosenEnrollmentPeriods[0].CODE === 'R'">
					<div>* Regular Start/End Dates: 7/1/{{getCurrentYear(selectedSchoolYear)}} -
						8/31/{{getNextYear(selectedSchoolYear)}} <span *ngIf="!cosMode">(Start/End dates within
							enrollment
							and withdrawal date)</span>
					</div>
				</div>
				<div class="row"
					*ngIf="selectedSchoolYear && chosenEnrollmentPeriods && chosenEnrollmentPeriods.length > 0 && chosenEnrollmentPeriods[0].CODE === 'S'">
					<div>* Summer Start Date: 5/15/{{getNextYear(selectedSchoolYear)}} -
						8/31/{{getNextYear(selectedSchoolYear)}} <span *ngIf="!cosMode">(Start date after withdrawal
							date)</span></div>
					<div>** Summer End Date: 5/15/{{getNextYear(selectedSchoolYear)}} -
						9/20/{{getNextYear(selectedSchoolYear)}} <span *ngIf="!cosMode">(No End Date
							restrictions)</span>
					</div>
					<div>*** Child(ren) must be of Age 3 or older</div>
				</div>
				<div class="row"
					*ngIf="selectedSchoolYear && chosenEnrollmentPeriods && chosenEnrollmentPeriods.length > 0 && chosenEnrollmentPeriods[0].CODE === 'I'">
					<div>* Intersession Start Date: 7/1/{{getCurrentYear(selectedSchoolYear)}} -
						8/31/{{getNextYear(selectedSchoolYear)}} <span *ngIf="!cosMode">(Start date after enrollment
							date)</span></div>
					<div>** Intersession End Date: Start Date - (31 days after Start Date) (No End Date restrictions)
					</div>
					<div>*** Child(ren) must be of Age 3 or older</div>
				</div>

				<div class="row" class="warn-font-color italic"
					*ngIf="cosMode && chosenEnrollmentPeriods && maxEndOfEligibilityStudent && maxEndOfEligibilityStudent.SCHOOL_ENROLLMENT_DETAILS![0].STUDENT_ELIGIBILITIES[0].ELIGIBILITY_END_DATE">
					Must be after EoE:
					{{maxEndOfEligibilityStudent.SCHOOL_ENROLLMENT_DETAILS![0].STUDENT_ELIGIBILITIES[0].ELIGIBILITY_END_DATE
					| cleanDate | simpleDate}}
				</div>

				<div class="row" class="warn-font-color italic"
					*ngIf="(startDateOptions.minDate >= startDateOptions.defaultMinDate || startDateOptions.maxDate <= startDateOptions.defaultMaxDate) && chosenEnrollmentPeriods && chosenEnrollmentPeriods.length > 0 && chosenEnrollmentPeriods[0].CODE === 'R' && startDateOptions.minDate < startDateOptions.maxDate">
					Valid Dates (Common School Enrollments): {{(restrictedDateOptions.minDate ?
					restrictedDateOptions.minDate
					: startDateOptions.minDate) | simpleDate}} {{restrictedDateOptions.minDate ? '(E)' : ''}} -
					{{(restrictedDateOptions.maxDate ? restrictedDateOptions.maxDate : startDateOptions.maxDate) |
					simpleDate}} {{restrictedDateOptions.maxDate ?
					'(Withdrawal/Termination/EoE)' : '(No Withdrawal Date)'}}
				</div>

				<div class="row" class="warn-font-color italic"
					*ngIf="(startDateOptions.minDate >= startDateOptions.defaultMinDate || startDateOptions.maxDate <= startDateOptions.defaultMaxDate) && chosenEnrollmentPeriods && chosenEnrollmentPeriods.length > 0 && chosenEnrollmentPeriods[0].CODE === 'I' && startDateOptions.minDate < startDateOptions.maxDate">
					Valid Dates (Common School Enrollments): {{(restrictedDateOptions.minDate ?
					restrictedDateOptions.minDate
					: startDateOptions.minDate) | simpleDate}} {{restrictedDateOptions.minDate ? '(E)' : ''}}
					{{(form.get('startDate')?.value ? ' - ' : '')}}
					{{(form.get('startDate')?.value ? endDateOptions.maxDate : '') |
					simpleDate}}
				</div>

				<div class="row" class="warn-font-color italic"
					*ngIf="(startDateOptions.minDate > startDateOptions.defaultMinDate) && chosenEnrollmentPeriods && chosenEnrollmentPeriods.length > 0 && chosenEnrollmentPeriods[0].CODE === 'S' && startDateOptions.minDate < startDateOptions.maxDate">
					Valid Dates (Common School Enrollments): On or after {{restrictedDateOptions.maxDate | simpleDate}}
					(W)
				</div>

				<div class="row" class="warn-font-color italic"
					*ngIf="(startDateOptions.minDate > startDateOptions.defaultMinDate) && chosenEnrollmentPeriods && chosenEnrollmentPeriods.length > 0 && (chosenEnrollmentPeriods[0].CODE === 'S' || chosenEnrollmentPeriods[0].CODE === 'I') && ageRestrictedStudent">
					Valid Dates (Child's third birthday [{{ageRestrictedStudent.MSD_NUMBER}}]): On or after
					{{restrictedDateOptions.minDate | simpleDate}}
				</div>

				<div class="row" class="warn-font-color italic"
					*ngIf="startDateOptions.minDate > startDateOptions.maxDate">
					No valid dates available.
				</div>

				<div class="row" *ngIf="dateFlags.length > 0">
					<div>
						<div class="danger bold" *ngFor="let creationFlag of creationFlags">
							{{creationFlag.NAME | titlecase}}'s
							<span *ngIf="creationFlag.MSD_NUMBER.length > 0">({{creationFlag.MSD_NUMBER}})</span>
							{{creationFlag.TYPE}} date {{creationFlag.DATE | simpleDate}}
							makes them ineligible for School Year {{selectedSchoolYear}}.
						</div>
					</div>
				</div>

			</form>

			<hr *ngIf="mode !== 'view'" />

			<div *ngIf="mode !== 'view' && !!serviceDelivery && !loadingChanges">
				<div class="row">
					<div class="col-lg-12" *ngIf="tableDataSource">
						<div *ngIf="tableDataSource.filteredData.length <= 0">
							No Changes
						</div>

						<div class="margin-top-sm table-responsive" *ngIf="tableDataSource.filteredData.length > 0">
							<h3>Current Changes ({{tableDataSource.filteredData.length}})</h3>
							<mat-table [dataSource]="tableDataSource" class="mat-elevation-z1" matSort>

								<ng-container matColumnDef="CHANGED_FIELD">
									<mat-header-cell *matHeaderCellDef> Field </mat-header-cell>
									<mat-cell *matCellDef="let element"> {{element.CHANGED_FIELD}} </mat-cell>
								</ng-container>

								<ng-container matColumnDef="VALUE">
									<mat-header-cell *matHeaderCellDef> Previous Value </mat-header-cell>
									<mat-cell *matCellDef="let element"> {{element.VALUE}} </mat-cell>
								</ng-container>

								<ng-container matColumnDef="CHANGED_VALUE">
									<mat-header-cell *matHeaderCellDef> New Value </mat-header-cell>
									<mat-cell *matCellDef="let element"> {{element.CHANGED_VALUE}} </mat-cell>
								</ng-container>

								<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
								<mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
							</mat-table>
						</div>
					</div>
				</div>
			</div>
			<mat-icon *ngIf="loadingChanges && mode !== 'view'">
				<mat-spinner diameter="20"> </mat-spinner>
			</mat-icon>

			<hr *ngIf="mode !== 'view' && !!serviceDelivery" />

			<div *ngIf="mode !== 'view'" class="inline">
				<button class="margin-bottom-xs" type="submit" *ngIf="!isSubmitting && !serviceDelivery"
					mat-raised-button color="primary" (click)="confirmPopup()"
					[disabled]="isSubmitting || (msg && msg.SUCCESS!)">
					Create
				</button>
				<confirm-popover *ngIf="!isSubmitting && serviceDelivery" class="margin-bottom-xs"
					[buttonType]="'string'" [color]="'primary'" [popoverMsg]="'Confirm Update to Service Participation'"
					[popoverConfirmText]="'Update'" [buttonTxt]="'Update'" [popoverConfirmColor]="'primary'"
					(onConfirm)="submit()" [disabled]="isSubmitting || (msg && msg.SUCCESS!)">
				</confirm-popover>

				<button type="button" mat-icon-button *ngIf="isSubmitting">
					<mat-icon>
						<mat-spinner diameter="20"> </mat-spinner>
					</mat-icon>
				</button>
				<app-msg class="margin-left-sm" [msg]="msg" *ngIf="msg?.MSG"></app-msg>
			</div>

			<hr *ngIf="serviceDelivery" />

			<div *ngIf="serviceDelivery">
				<tracking-history [formName]="'ServiceParticipation'"
					[formID]="serviceDelivery.ID.toString()"></tracking-history>
			</div>
		</div>
	</mat-card-content>
</mat-card>